var map = {
	"./collection.png": 269,
	"./domiart.svg": 1058,
	"./edit.svg": 396,
	"./font/Fontfabric - MullerBlackItalic.otf": 1059,
	"./font/Fontfabric - MullerBold.otf": 1060,
	"./font/Fontfabric - MullerBoldItalic.otf": 1061,
	"./font/Fontfabric - MullerExtraBold.otf": 1062,
	"./font/Fontfabric - MullerExtraBoldItalic.otf": 1063,
	"./font/Fontfabric - MullerHairline.otf": 1064,
	"./font/Fontfabric - MullerHairlineItalic.otf": 1065,
	"./font/Fontfabric - MullerHeavy.otf": 1066,
	"./font/Fontfabric - MullerHeavyItalic.otf": 1067,
	"./font/Fontfabric - MullerLightItalic.otf": 1068,
	"./font/Fontfabric - MullerMedium.otf": 1069,
	"./font/Fontfabric - MullerMediumItalic.otf": 1070,
	"./font/Fontfabric - MullerRegularItalic.otf": 1071,
	"./font/Fontfabric - MullerThin.otf": 1072,
	"./font/Fontfabric - MullerThinItalic.otf": 1073,
	"./font/Fontfabric - MullerUltraLight.otf": 1074,
	"./font/Fontfabric - MullerUltraLightItalic.otf": 1075,
	"./font/MullerBlack.otf": 1076,
	"./font/MullerLight.otf": 1077,
	"./font/MullerRegular.otf": 428,
	"./logo.aed13c04.svg": 1078,
	"./logo.divotex.svg": 1079,
	"./logo.svg": 1080,
	"./remove.svg": 397,
	"./store.png": 133,
	"./store.png_old": 1081
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 427;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 427
// module chunks = 0